<template>
  <v-card class="box">
    <v-radio-group v-model="selectedSize">
      <v-radio
           v-for="n in exportTypes"
           :key = "n.value"
           :label = "$t(n.text)"
           :value = "n.value"
         ></v-radio>
      </v-radio-group>
      <div v-if="selectedSize === 3">
        <v-text-field variant="underlined" v-model="customSize.width" :label="$t('map.generator.width_in_pixels')"/>
        <v-text-field variant="underlined" v-model="customSize.height" :label="$t('map.generator.height_in_pixels')"/>
      </div>
      <v-btn rounded color="secondary mr-sm-4" @click="closeDialog" >{{$t('map.generator.cancel')}}</v-btn>
      <SaveButton
          @save="exportData"
          :label="$t('map.generator.export')"
      />
  </v-card>
</template>


<script>
    import SaveButton from "@/components/buttons/SaveButton";
    export default {
        name: 'ExportSize',

        components: {
          SaveButton,
        },

        props: {
            value: String,
        },

        data() {
          return {
            exportTypes: [
              { text: 'map.generator.big', value: 0 },
              { text: 'map.generator.medium', value: 1 },
              { text: 'map.generator.small', value: 2 },
              { text: 'map.generator.own', value: 3 },
            ],
            customSize: {
              width: 1920,
              height: 1080,
            },
            selectedSize: null,
            exportSizes: [
              { width: 1920, height: 1080 },
              { width: 1280, height: 720 },
              { width: 860, height: 640 },
            ]
          }
        },

        methods: {
          closeDialog() {
              this.$emit('closeDialog');
          },

          exportData() {
            const size = this.selectedSize == 3 ? this.customSize : this.exportSizes[this.selectedSize];
            this.$emit('export', size);
          }
        },
    }
</script>

<style scoped>
  .box {
    padding: 20px;
  }
</style>
